import type { HeroBox } from './realImages';

// Air around a box a MODEL drew.
//
// It frames the product as asked — tightly — which on a splash reads as cramped, and
// shaves a chair leg or a foot off wherever its edge was a percent optimistic. A few
// percent of the picture costs nothing and buys back the whole product, plus room to
// breathe. 1.5% was tried and was not enough.
const CROP_MARGIN = 0.04;

// The model's box, plus its air, clamped to the picture.
//
// Applied ONCE, where the box arrives, so that from then on there is a single box and
// it means one thing: what will be cut. It used to be added at crop time instead, which
// left the picker outlining the model's bare box while the splash shipped something
// slightly larger — asking the user to judge a frame that was not the one they got.
//
// So it is never applied to a box the user dragged: they framed what they wanted, on
// screen, at the size it ships. Quietly growing that by 4% would second-guess the one
// person here who was actually looking — and adding air to a box that already has it
// would do it twice.
//
// Its own module because both the crop and the store that holds the box need it, and
// the store cannot import the crop: the crop reads the store.
export function withMargin(box: HeroBox, margin = CROP_MARGIN): HeroBox {
  return [
    Math.max(0, box[0] - margin),
    Math.max(0, box[1] - margin),
    Math.min(1, box[2] + margin),
    Math.min(1, box[3] + margin),
  ];
}
